import { render, staticRenderFns } from "./field.vue?vue&type=template&id=6040d490&scoped=true&"
import script from "./field.vue?vue&type=script&lang=js&"
export * from "./field.vue?vue&type=script&lang=js&"
import style0 from "./field.vue?vue&type=style&index=0&id=6040d490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6040d490",
  null
  
)

export default component.exports